import { Component, Input, Output, TemplateRef, ViewChild, EventEmitter, ChangeDetectorRef, OnInit, OnDestroy } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Frequency } from "../../enums/subscriptionFrequency";
import { ICountry } from "../../interfaces/icountry";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { AppSettings } from "../../appsettings";
import { PortalSubscriptionService } from "../../services/portalsubscription.service";
import { IPortalSubscription } from "../../interfaces/iportalsubscription";
import { AuthService } from "../../services/auth.service";

@Component({
    selector: "email-subscription-modal",
    templateUrl: "./emailSubscriptionModal.component.html",
    standalone: false
})

export class EmailSubscriptionModalComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    portalSubscriptionDTO!: IPortalSubscription;
    IsDivVisible: boolean = false;

    constructor(private modalService: BsModalService, private portalSubscriptionService: PortalSubscriptionService, private cd: ChangeDetectorRef) {
    }
    Immediate!: number;
    Weekly!: number;
    Monthly!: number;
    EmailYes!: boolean;
    EmailNo!: boolean;
    filterApplied: boolean = false;
    selectAllCounter: number = 0;
    countries!: ICountry[];
    selectAll: boolean = false;
    EmailDigest!: FormGroup;
    submitted = false;
    emailRegex: string = AppSettings.emailRegExp.source;
    emailAddress: string = '';
    isPrivatePortal: boolean = false;

    selectedCountry: number = 0;

    @ViewChild("emailSubscription") emailSubscriptionModel!: TemplateRef<any>;
    @Input('countryData') countriesData!: ICountry[]
    @Output() formSubmit = new EventEmitter<string>();
    modalInstance!: BsModalRef;

    ngOnInit(): void {
        this.Immediate = Frequency.Immediate;
        this.Weekly = Frequency.Weekly;
        this.Monthly = Frequency.Monthly;
        this.EmailYes = true;
        this.EmailNo = false;
        this.countries = this.countriesData;
        this.createForm();
        this.cd.detectChanges();
    }

    createForm() {
        this.emailAddress = (sessionStorage['currentClientUser'] != null || sessionStorage['currentClientUser'] != undefined) ? JSON.parse(sessionStorage['currentClientUser']).email : '';
        this.isPrivatePortal = (this.emailAddress != null && this.emailAddress != "");
        this.EmailDigest = new FormGroup({
            notify: new FormControl('', [Validators.required]),
            frequency: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required, Validators.email, Validators.pattern(this.emailRegex)]),
            userCountries: new FormGroup({})
        });
    }

    Open(): void {
        this.closePopup(false);
        const userCountriesGroup: FormGroup = this.EmailDigest.controls["userCountries"] as FormGroup;
        this.countries.forEach(item => {
            userCountriesGroup.addControl(item.id.toString(), new FormControl(false));
        });

        this.EmailDigest.patchValue({
            email: this.emailAddress,
            notify: false
        });

        if (this.isPrivatePortal)
            this.getSubscriptionDetailsByEmail();

        this.modalInstance = this.modalService.show(this.emailSubscriptionModel, { "class": "modal-lg" });
    }

    closePopup(reset: boolean = false): void {
        this.selectedCountry = 0;
        this.EmailDigest.reset();
        this.EmailDigest.markAsPristine();
        this.EmailDigest.markAsUntouched();
        if (reset)
            this.modalInstance.hide();
        this.submitted = false;
        this.selectAll = false;
        this.countries = this.countriesData;
        this.filterApplied = false;
        this.selectAllCounter = 0;
        this.IsDivVisible = false;
    }

    saveSubscription(portalSubscriptionDTO: IPortalSubscription) {
        this.submitted = true;
        if (this.IsDivVisible && this.EmailDigest.valid && this.selectedCountry > 0) {
            portalSubscriptionDTO.countryIds = this.getSelectedCountries(portalSubscriptionDTO.userCountries)
            this.portalSubscriptionService.createUpdate(portalSubscriptionDTO)
                .pipe(takeUntil(this.destroy$))
                .subscribe(() => {
                    this.closePopup(true);
                    this.formSubmit.emit("Email digest changes saved successfully​.");
                });
        }
        else if (!this.IsDivVisible && this.EmailDigest.controls["email"].valid && !this.EmailDigest.controls["notify"].value) {
            this.portalSubscriptionService.Delete(this.EmailDigest.controls["email"].value)
                .pipe(takeUntil(this.destroy$))
                .subscribe((response) => {
                    let message = "No email digest found.";
                    if (response) {
                        message = "Email digest removed successfully.";
                    }
                    this.closePopup(true);
                    this.formSubmit.emit(message);
                });
        }
    }

    getSubscriptionDetailsByEmail() {
        let emailAddress = this.EmailDigest.controls["email"].value;
        const currentThis = this;

        if (this.EmailDigest.controls["email"].valid) {
            this.portalSubscriptionService.GetSubscription(emailAddress)
                .pipe(takeUntil(this.destroy$))
                .subscribe((response: any) => {                    
                    if (response.id != null) {
                        currentThis.IsDivVisible = true;
                    }
                    else {
                        currentThis.IsDivVisible = false;
                    }

                    currentThis.EmailDigest.patchValue({
                        email: response.email,
                        notify: response.isNotify,
                        frequency: response.frequency > 0 ? response.frequency : null,
                        userCountries: response.countryIds
                    });

                    const userCountriesGroup: FormGroup = currentThis.EmailDigest.controls["userCountries"] as FormGroup;
                    Object.keys(userCountriesGroup.controls).forEach(key => {
                        userCountriesGroup.controls[key].setValue(false);
                    });

                    if (response.countryIds.length > 0) {
                        Object.keys(userCountriesGroup.controls).forEach(key => {
                            response.countryIds.forEach((item: number) => {
                                if (item.toString() === key) {
                                    userCountriesGroup.controls[key].setValue(true);
                                }
                            });
                        });
                    }
                    let totalLength = currentThis.filterApplied ? currentThis.countries.length : currentThis.countriesData.length;
                    if (totalLength <= Object.keys(userCountriesGroup.controls).map(key => userCountriesGroup.controls[key]).filter(control => control.value === true).length) {
                        currentThis.selectAll = true;
                    }
                    else {
                        currentThis.selectAll = false;
                    }
                    currentThis.selectedCountry = Object.keys(userCountriesGroup.controls).map(key => userCountriesGroup.controls[key]).filter(control => control.value === true).length;
                });
        }
    }

    getUserCountriesFormGroup(): FormGroup {
        return this.EmailDigest.controls['userCountries'] as FormGroup;
    }

    filterGeography(value: string) {
        if (!value) {
            this.countries = this.countriesData;
            this.filterApplied = false;
        } else {
            this.countries = this.countriesData.filter(country =>
                country.shortName.toLowerCase().includes(value.toLowerCase()) ||
                country.name.toLowerCase().includes(value.toLowerCase())
            );
            this.filterApplied = true;
        }
    }

    divShowHide(show: boolean) {
        this.IsDivVisible = show;
    }

    selectAllCountries(event: any) {
        const isChecked = event.target.checked;
        this.selectAll = isChecked;

        const userCountriesGroup: FormGroup = this.EmailDigest.controls["userCountries"] as FormGroup;
        Object.keys(userCountriesGroup.controls).forEach(key => {
            userCountriesGroup.controls[key].setValue(isChecked);
        });

        this.selectedCountry = isChecked ? this.countries.length : 0;
    }

    onCheckboxChange(event: any) {
        const userCountriesGroup: FormGroup = this.EmailDigest.controls["userCountries"] as FormGroup;
        this.selectedCountry = Object.keys(userCountriesGroup.controls)
            .map(key => userCountriesGroup.controls[key])
            .filter(control => control.value === true).length;

        const totalLength = this.filterApplied ? this.countries.length : this.countriesData.length;
        this.selectAll = (totalLength === this.selectedCountry);
    }

    getSelectedCountries(userCountries: any): number[] {
        const selectedIds: number[] = [];
        Object.keys(userCountries).forEach(key => {
            if (userCountries[key] === true) {
                selectedIds.push(parseInt(key));
            }
        });
        return selectedIds;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}